<script setup lang="ts">
export interface BingoInfoProps {
    howToTitle?: string
    howToItems: string[]
}

const props = defineProps<BingoInfoProps>()
</script>

<template>
    <div class="bingo-info">
        <div class="bingo-info__intro">
            <div class="bingo-info__intro-sub">
                <slot name="intro" />
            </div>
            <div v-if="$slots.video" class="bingo__phone">
                <div class="bingo__video bingo__video--signup">
                    <slot name="video" />
                </div>
            </div>
        </div>

        <h2 class="bingo-info__how-to__header">
            {{ props.howToTitle }}
        </h2>
        <div class="bingo-info__how-to">
            <ul>
                <!-- eslint-disable-next-line vue/no-v-html item is safe -->
                <li v-for="(item, index) in props.howToItems" :key="index" v-html="item" />
            </ul>
        </div>
    </div>
</template>

<style lang="scss">
.bingo-info {
    &__intro {
        display: flex;
        flex-direction: column;

        @media (min-width: $screen-lg) {
            display: flex;
            margin-top: 20px;
        }

        &-text {
            font-weight: $text-medium;

            @media (min-width: $screen-md) {
                font-size: 20px;
            }

            @media (min-width: $screen-lg) {
                max-width: 510px;
                padding-top: 40px;
            }
        }

        &-image {
            align-self: center;
            margin-top: 5rem;
            object-fit: contain;
        }

        &-sub {
            // Temporary fix to layout shift due to random <b> inserted on render oO
            &,
            > b {
                display: flex;
                flex-direction: column;

                @media (min-width: $screen-lg) {
                    flex-direction: row;
                }
            }
        }
    }

    &__subwelcome {
        max-width: 800px;

        @media (min-width: $screen-lg) {
            margin-left: 5rem;
        }
    }

    &__welcome {
        padding: 100px 0;
    }

    &__how-to {
        margin-bottom: 50px;

        @media (min-width: $screen-lg) {
            margin-bottom: 100px;
        }

        &__header {
            @media (min-width: $screen-md) and (max-width: $screen-lg) {
                text-align: center;
            }
        }

        ul {
            counter-reset: howto;
            padding-left: 15px;
            list-style: none;

            @media (min-width: $screen-lg) {
                display: grid;
                margin-left: -15px;
                padding-left: 0;
                grid-template-columns: repeat(3, 1fr);
                grid-template-rows: 1fr;
                grid-column-gap: 30px;
            }
        }

        li {
            counter-increment: howto;
            position: relative;
            margin-bottom: 18px;
            padding: 15px 15px 15px 30px;
            border-radius: var(--border-radius-lg, $border-radius-lg);
            background: var(--panel-bg, $panel-color);

            @media (min-width: $screen-md) {
                max-width: 70%;
                margin-bottom: 25px;
                font-size: 21px;
            }

            @media (min-width: $screen-md) and (max-width: $screen-lg) {
                margin: 0 auto 25px;
                text-align: center;
            }

            @media (min-width: $screen-lg) {
                max-width: none;
                margin: 0 15px;
            }

            &::before {
                display: flex;
                position: absolute;
                top: 5px;
                left: -15px;
                justify-content: center;
                align-items: center;
                width: 35px;
                height: 35px;
                border-radius: 50%;
                color: $on-cta;
                background: $cta-bg;
                font-size: 20px;
                font-weight: 900;
                content: counter(howto);

                .bingo--90 & {
                    background: $bingo-green;
                }
            }
        }
    }
}
</style>
